import React from "react";
import { Ghost as GhostIcon } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-[#BAE6FD] py-14 md:py-20 bg-[#F4FAFF]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-full bg-[#84C5F4] grid place-items-center text-white">
              <GhostIcon size={20} strokeWidth={2.5} />
            </span>
            <span className="font-display text-lg font-semibold text-[#051937]">
              Tonek <span className="font-script text-[#60A5FA] text-2xl">i</span> Duszek
            </span>
          </div>
          <p className="mt-6 text-[#0b2a55]/80 max-w-sm leading-relaxed">
            Bajkowa marka dla dzieci, które nie chcą, żeby historie się kończyły.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.24em] font-bold text-[#0b2a55]/70">
            Odkryj
          </h4>
          <ul className="mt-5 space-y-3 text-[#051937] font-semibold">
            <li>
              <a className="animated-underline" href="#bajki" data-testid="footer-bajki">
                Bajki
              </a>
            </li>
            <li>
              <a className="animated-underline" href="#manifest" data-testid="footer-manifest">
                Manifest
              </a>
            </li>
            <li>
              <a className="animated-underline" href="#historia" data-testid="footer-historia">
                Historia
              </a>
            </li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.24em] font-bold text-[#0b2a55]/70">
            Napisz
          </h4>
          <ul className="mt-5 space-y-3 text-[#051937] font-semibold">
            <li>
              <a className="animated-underline" href="mailto:hej@tonekiduszek.pl">
                hej@tonekiduszek.pl
              </a>
            </li>
            <li>
              <a className="animated-underline" href="https://www.instagram.com/tonekiduszek" target="_blank" rel="noreferrer">
                Instagram · @tonekiduszek
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.24em] text-[#0b2a55]/60 font-semibold">
        <span>© {new Date().getFullYear()} Tonek i Duszek — wszystkie sny zastrzeżone</span>
        <span>Made with wonder in PL</span>
      </div>
    </footer>
  );
}
